import xHttp from '@utils/xHttp';
import { getBaseAwsApiUrl, getContentfulApiVersion } from '@utils/config';

export const getSummary = () => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/newsroom/summary`;

  return xHttp.get(url);
};

export const getPressReleases = () => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/newsroom/press-releases`;

  return xHttp.get(url);
};

export const getFullPressRelease = (slug) => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/newsroom/press-releases/${slug}`;

  return xHttp.get(url);
};

export const searchPressReleases = (text) => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/newsroom/press-releases?search=${text}`;

  return xHttp.get(url);
};

export const getNewsMentions = () => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/newsroom/news-mentions`;

  return xHttp.get(url);
};

export const getBranding = () => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/newsroom/branding`;

  return xHttp.get(url);
};

export const getResources = () => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/newsroom/resources`;

  return xHttp.get(url);
};

export const getLatestResources = () => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/newsroom/resources/latest?count=9`;

  return xHttp.get(url);
};

export const searchResources = (text) => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/newsroom/resources?search=${text}`;

  return xHttp.get(url);
};
